import { Form } from '@unform/web';
import styled from 'styled-components';

export const Container = styled.div`
  display: grid;
  flex-direction: row;
  padding: 1rem 0 0 0;
  width: 100%;
  align-content: center;
  align-self: center;

  button {
    margin-top: 0.1rem;
    margin-bottom: 1.1rem;
    width: 40rem;
  }
`;

export const Graph = styled.div`
  height: calc(100vh - 6rem);
`;

export const ContainerForm = styled(Form)`
  > div:not(:last-child) {
    margin-bottom: 2rem;
  }

  p.MuiFormHelperText-root.Mui-error {
    margin-top: 0;
  }
`;
